import React, { useState } from 'react';
import axios from 'axios';
import { FileArchive, Download } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const BoardPackCard = () => {
  const [month, setMonth] = useState(() => {
    const d = new Date();
    d.setMonth(d.getMonth() - 1);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  });
  const [downloading, setDownloading] = useState(false);

  const download = async () => {
    setDownloading(true);
    try {
      const r = await axios.get(`${API_URL}/api/finance/board-pack`, {
        params: { month }, responseType: 'blob',
      });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `suubi_board_pack_${month}.zip`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success(`Board pack for ${month} downloaded — 8 reports bundled`);
    } catch {
      toast.error('Failed to generate board pack');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Card data-testid="board-pack-card">
      <CardHeader className="pb-2">
        <CardTitle className="font-heading text-base flex items-center gap-2">
          <FileArchive className="h-4 w-4 text-primary" /> Monthly Board Pack
        </CardTitle>
        <CardDescription>
          One-click ZIP bundle: income statement, expense, school, women project, funding source, requisition & withdrawal reports
        </CardDescription>
      </CardHeader>
      <CardContent className="flex items-center gap-3">
        <Input type="month" value={month} onChange={(e) => setMonth(e.target.value)}
          className="w-44" data-testid="board-pack-month" />
        <Button onClick={download} disabled={downloading || !month} data-testid="board-pack-download-btn">
          <Download className="mr-2 h-4 w-4" /> {downloading ? 'Bundling…' : 'Download Board Pack'}
        </Button>
      </CardContent>
    </Card>
  );
};
